// Số liệu mẫu của Mint-Import-iPad / -iPad-Detail / -Phone (ĐỌC từ code board, money = hide → không có cột tiền).
import type { ImportTab } from './types';

export type PadTone = 'grey' | 'amber' | 'red' | 'green' | 'blue' | 'violet';
export interface PadItem {
  id: string;
  k: string;
  s: string;
  chip: string;
  tone: PadTone;
  /** chỉ tab DEM/DET: [free khách, đã dùng] */
  clock?: [number, number];
}
export interface PadStep { k: string; v: string; done: boolean; cur: boolean }
export interface PadDetail {
  kind: string;
  alert: string;
  alertTone: 'warn' | 'err';
  pairs: [string, string][];
  stepK: string;
  steps: PadStep[];
  acts: [string, 'pri' | 'warn'][];
}

export const PAD_TABS: readonly { key: ImportTab; label: string; n: number; back: string }[] = [
  { key: 'imp', label: 'Hàng nhập', n: 3, back: 'Hàng nhập' }, { key: 'dd', label: 'DEM/DET', n: 3, back: 'DEM/DET' }, { key: 'lane', label: 'Luồng HQ', n: 3, back: 'Luồng HQ' },
  { key: 'rf', label: 'Lạnh', n: 2, back: 'Hàng lạnh' }, { key: 'dep', label: 'Cược', n: 2, back: 'Cược' }, { key: 'clm', label: 'Sự cố', n: 2, back: 'Sự cố' },
];

const DOK = { ok: ['Sẵn sàng phát DO', 'green'], issued: ['Đã phát DO', 'grey'], unpaid: ['DO khoá · chưa thanh toán', 'amber'], overdue: ['DO khoá · quá hạn nợ', 'red'], over: ['DO khoá · vượt hạn mức', 'red'] } as const;
const LANE = { G: ['Xanh', 'green'], Y: ['Vàng', 'amber'], R: ['Đỏ', 'red'], X: ['Soi chiếu', 'violet'] } as const;
const RFS = { dev: ['Lệch 6,8 °C', 'red'], miss: ['Thiếu ảnh', 'amber'], ok: ['Đạt', 'green'] } as const;
const DEPS = { decide: ['Chờ Trưởng CS', 'amber'], late: ['Quá hạn hoàn', 'red'], wait: ['Chờ hoàn', 'blue'], hana: ['HANA chịu', 'violet'] } as const;
const CLS = { open: ['Mở', 'blue'], chase: ['Đang đòi', 'amber'], bod: ['Chờ BOD', 'violet'], closed: ['Chốt', 'green'] } as const;

/** [tiêu đề, phụ, trạng thái | free khách, đã dùng] theo từng tab (board Mint-Import-iPad). */
const RAW: Record<ImportTab, readonly (readonly (string | number)[])[]> = {
  imp: [['RI260650400', 'NPFruit · 1×40RH · ETA 23/Oct', 'unpaid'], ['RI250628690', 'NDP · 1×40RH · ETA 21/Oct', 'overdue'], ['RI260644890', 'THANHHAO · 1×20RF · ETA 22/Oct', 'ok'], ['RI250578840', 'HUONGDUA · 1×20DC · ETA 24/Oct', 'over'], ['RI250587880', 'RuiTong-SC · 3×20DC · ETA 20/Oct', 'issued']],
  dd: [['FBIU5484924', 'NDP · KMTC · DEM + điện', 7, 9, 'RF'], ['FSCU5889728', 'NPFruit · ONE · DEM', 7, 6, 'DC'], ['OOLU0320399', 'RuiTong-SC · HMM · DET', 7, 8, 'DC'], ['TRIU6670229', 'THANHHAO · Wan Hai · DET', 10, 4, 'DC'], ['FBIU5232460', 'VJTrading · CMA CGM · DET', 12, 11, 'DC']],
  lane: [['105928817420', 'NPFruit · kiểm 23/Oct 08:30', 'R'], ['105928811032', 'THANHHAO · kiểm hồ sơ', 'Y'], ['105928806654', 'NEWWIND · soi CMIT 14:00', 'X'], ['105928799018', 'RuiTong-SC', 'G']],
  rf: [['SZLU2019991', 'NDP · cài −18,0 °C', 'dev'], ['YMLU5438708', 'EMDEES · cài +13,0 °C', 'miss'], ['FBIU5484924', 'NDP · cài −18,0 °C', 'ok'], ['SEGU9974345', 'COCOGROUP · cài +4,0 °C', 'ok']],
  dep: [['FBIU5232460', 'VJTrading · CMA CGM · có khoản trừ', 'decide'], ['MEDU 410028-5', 'HUONGDUA · MSC · dự kiến hoàn 13/Oct', 'late'], ['OOLU0320399', 'RuiTong-SC · HMM · dự kiến hoàn 04/Nov', 'wait'], ['ONEU 330981-4', 'NPFruit · ONE · có khoản trừ', 'hana']],
  clm: [['CLM-2610-07', 'NDP · lệch nhiệt độ · hãng tàu', 'open'], ['CLM-2610-05', 'NEWWIND · móp 3 kiện · nhà xe', 'chase'], ['CLM-2610-01', 'EMDEES · chậm giao · HANA', 'bod'], ['CLM-2610-03', 'VJTrading · vỡ 12 thùng · kho', 'closed']],
};
export const MINE = ['NDP', 'NPFruit', 'RuiTong-SC'] as const;

export function ddMeta(free: number, used: number): { left: number; chip: string; tone: PadTone } {
  const left = free - used;
  return { left, chip: left < 0 ? 'Quá free time' : left <= 2 ? 'Sắp hết' : 'Trong hạn', tone: left < 0 ? 'red' : left <= 2 ? 'amber' : 'blue' };
}

export function padItems(tab: ImportTab, noperm: boolean): PadItem[] {
  const rows = noperm ? RAW[tab].filter((r) => MINE.some((c) => String(r[1]).startsWith(c))) : RAW[tab];
  return rows.map((r, i) => {
    const id = `${tab}${i}`;
    const k = String(r[0]);
    const s = String(r[1]);
    if (tab === 'dd') { const m = ddMeta(Number(r[2]), Number(r[3])); return { id, k, s, chip: m.chip, tone: m.tone, clock: [Number(r[2]), Number(r[3])] as [number, number] }; }
    const map = (tab === 'imp' ? DOK : tab === 'lane' ? LANE : tab === 'rf' ? RFS : tab === 'dep' ? DEPS : CLS) as Record<string, readonly [string, PadTone]>;
    const [chip, tone] = map[String(r[2])]!;
    return { id, k, s, chip, tone };
  });
}

const st = (k: string, v: string, done: boolean, cur = false): PadStep => ({ k, v, done, cur: !done && cur });

/** Chi tiết theo bản ghi (không tiền). */
export function padDetail(tab: ImportTab, it: PadItem): PadDetail {
  const raw = RAW[tab].find((_, i) => `${tab}${i}` === it.id) ?? RAW[tab][0]!;
  const key = String(raw[2]);
  if (tab === 'imp') {
    const lock = ['unpaid', 'overdue', 'over'].includes(key);
    return {
      kind: 'Lô nhập', alertTone: 'warn',
      alert: lock ? `DO tự khoá vì khách ${key === 'unpaid' ? 'chưa thanh toán lô' : key === 'overdue' ? 'quá hạn công nợ 38 ngày' : 'vượt hạn mức'}. Phát trước cần Sale đề nghị → ${key === 'unpaid' ? 'Trưởng KD' : 'KTT'} duyệt, có log.` : '',
      pairs: [['Pre-alert', 'Đủ · 15/Oct/2026'], ['MBL', 'ONEYKHHA1234'], ['Hạn mức', key === 'over' ? 'Vượt hạn mức' : 'Trong hạn mức'], ['CS phụ trách', 'THUỶ']],
      stepK: 'Hành trình nhập', steps: [st('Pre-alert', '15/Oct/2026', true), st('ETA', `${it.s.split('ETA ')[1]}/2026`, true), st('Thông quan', 'xem tab Luồng HQ', false, true), st('Phát DO', DOK[key as keyof typeof DOK][0], key === 'issued')],
      acts: lock ? [['Nhắc khách thanh toán', 'pri'], ['Đề nghị phát DO', 'warn']] : [[key === 'issued' ? 'Gửi lại DO' : 'Phát DO', 'pri']],
    };
  }
  if (tab === 'dd') {
    const left = Number(raw[2]) - Number(raw[3]);
    const det = it.s.includes('DET');
    return {
      kind: `Container · ${it.s.split(' · ')[2]}`, alertTone: left < 0 ? 'err' : 'warn',
      alert: left < 0 ? `Quá free time khách ${-left} ngày — phí dự kiến đã sinh hai bên (mua/bán), chờ CS xác nhận số ngày.` : left <= 2 ? `Còn ${left} ngày làm việc — task DMD đã giao CS, mail khách soạn sẵn.` : '',
      pairs: [['Free time hãng', `${Number(raw[2]) - 2} ngày`], ['Free time khách', `${raw[2]} ngày`], ['Đã dùng', `${raw[3]} ngày`], ['Cắm điện', raw[4] === 'RF' ? 'Có · tính chung DEM' : 'Không']],
      stepK: 'Mốc container', steps: [st('Dỡ hàng', '16/Oct/2026 · ePort', true), st('Lấy cont', det ? '14/Oct/2026' : 'chưa lấy', det, !det), st('Trả rỗng', 'chưa trả', false, det)],
      acts: [['Báo khách', 'pri']],
    };
  }
  if (tab === 'lane') {
    const [lk] = LANE[key as keyof typeof LANE];
    return {
      kind: 'Tờ khai nhập', alertTone: 'warn',
      alert: key === 'G' ? '' : `Luồng ${lk.toLowerCase()}: mail khách soạn sẵn, CS gửi. Phí theo biểu tự sinh; phí ngoài biểu cần khách xác nhận (myHANA/mail).`,
      pairs: [['Luồng', lk], ['Nguồn', 'Dịch vụ CCF'], ['Phí ngoài biểu', key === 'R' ? 'Rút ruột 2×40HC' : '—'], ['OPS hiện trường', 'HẢI']],
      stepK: 'Thông quan', steps: [st('Truyền tờ khai', '20/Oct/2026', true), st('Phân luồng', lk, true), st('Kiểm hoá / soi', key === 'G' ? 'không' : 'chờ', key === 'G', key !== 'G'), st('Thông quan', '—', false)],
      acts: [['Gửi mail khách', 'pri'], ['Phí ngoài biểu', 'warn']],
    };
  }
  if (tab === 'rf') {
    const dev = key === 'dev';
    return {
      kind: 'Cont lạnh', alertTone: 'err',
      alert: dev ? 'Ảnh lúc nhận −11,2 °C so với cài −18,0 °C (dung sai 2 °C). Đã báo CS (K4).' : key === 'miss' ? 'HANA Mov chưa gửi ảnh nhiệt độ lúc nhận cont.' : '',
      pairs: [['Cài đặt · vent', `${it.s.split('cài ')[1]} · đóng`], ['PTI', key === 'miss' ? 'Chờ PTI' : 'Đạt'], ['Tài xế', 'HẢI · 51C-482.19'], ['Job', 'SE260637290']],
      stepK: 'Kiểm nhiệt độ', steps: [st('PTI', 'Đạt', key !== 'miss'), st('Ảnh lúc nhận', dev ? 'lệch' : '', key === 'ok', key !== 'ok'), st('Ảnh lúc hạ', '', false)],
      acts: dev ? [['Gọi tài xế', 'pri'], ['Mở sự cố K4', 'warn']] : [['Nhắc điều độ chụp ảnh', 'pri']],
    };
  }
  if (tab === 'dep') {
    return {
      kind: 'Cược container', alertTone: key === 'late' ? 'err' : 'warn',
      alert: key === 'late' ? 'Quá hạn hoàn 9 ngày — task CDR đã giao HÀ.' : key === 'decide' || key === 'hana' ? 'Khoản trừ (vệ sinh cont). Có EIR/ảnh → tính khách; không → HANA chịu. Trưởng CS duyệt.' : '',
      pairs: [['Trả rỗng', '13/Oct/2026'], ['Dự kiến hoàn', '27/Oct/2026'], ['Đã hoàn', 'Chờ hoàn'], ['Bằng chứng', 'EIR + 3 ảnh']],
      stepK: 'Hoàn cược', steps: [st('Đóng cược', '08/Oct/2026', true), st('Trả rỗng · EIR', '13/Oct/2026', true), st('Hãng hoàn', 'chờ', false, true)],
      acts: key === 'late' ? [['Đòi hãng hoàn cược', 'pri']] : [['Tính khách', 'pri'], ['HANA chịu', 'warn']],
    };
  }
  return {
    kind: 'Hồ sơ sự cố', alertTone: 'warn',
    alert: key === 'bod' ? 'Phần HANA chịu vượt ngưỡng → BOD duyệt trước khi chốt, sau đó ghi vào Costing của job.' : '',
    pairs: [['Bên có lỗi', it.s.split(' · ')[2] ?? '—'], ['Hạn thông báo', key === 'open' ? '24/Oct/2026 · task CLM' : '—'], ['Bảo hiểm', 'Không mua']],
    stepK: 'Tiến trình', steps: [st('Mở', '20/Oct/2026', true), st('Đang đòi', '', key !== 'open', key === 'open'), st('Chốt', '', key === 'closed', key === 'bod')],
    acts: [['Gửi thông báo tổn thất', 'pri'], [key === 'bod' ? 'Gửi BOD duyệt' : 'Chốt hồ sơ', 'warn']],
  };
}

// ---------- Điện thoại (Mint-Import-Phone) ----------
export type PhoneSeg = 'all' | 'soon' | 'over';
export const PHONE_SEGS: readonly { key: PhoneSeg; label: string }[] = [{ key: 'all', label: 'Tất cả' }, { key: 'soon', label: 'Sắp hết' }, { key: 'over', label: 'Quá hạn' }];
export interface PhoneCont { k: string; job: string; cus: string; car: string; kind: string; ftC: number; ftK: number; used: number; set: string; vent: string; rf: boolean }
export const PHONE_CONTS: readonly PhoneCont[] = [
  { k: 'SZLU2019991', job: 'SE260637290', cus: 'MKSF', car: 'Heung-A', kind: 'DET + điện', ftC: 5, ftK: 7, used: 6, set: '−18,0 °C', vent: 'Đóng', rf: true },
  { k: 'FBIU5484924', job: 'RI250628690', cus: 'NDP', car: 'OOCL', kind: 'DEM + điện', ftC: 5, ftK: 7, used: 9, set: '−18,0 °C', vent: 'Đóng', rf: true },
  { k: 'FSCU5889728', job: 'RI260650400', cus: 'NPFruit', car: 'Heung-A', kind: 'DEM', ftC: 5, ftK: 7, used: 6, set: '—', vent: '—', rf: false },
  { k: 'OOLU0320399', job: 'RI250578840', cus: 'HUONGDUA', car: 'OOCL', kind: 'DET', ftC: 7, ftK: 7, used: 8, set: '—', vent: '—', rf: false },
  { k: 'TRIU6670229', job: 'RI260644890', cus: 'THANHHAO', car: 'Heung-A', kind: 'DET', ftC: 7, ftK: 10, used: 4, set: '—', vent: '—', rf: false },
];
export const phoneLeft = (c: PhoneCont): number => c.ftK - c.used;
export function phoneShots(c: PhoneCont, i: number): { k: string; v: string; state: 'ok' | 'bad' | 'cap' }[] {
  if (c.rf) return [{ k: 'PTI depot', v: '21/Oct 16:20 · Đạt', state: 'ok' }, { k: 'Lúc nhận cont', v: i === 0 ? '−11,2 °C · lệch' : '−17,6 °C', state: i === 0 ? 'bad' : 'ok' }, { k: 'Lúc hạ cont', v: 'Chạm để chụp', state: 'cap' }, { k: 'EIR', v: 'Chạm để chụp', state: 'cap' }];
  return [{ k: 'EIR lúc lấy', v: '14/Oct · 2 ảnh', state: 'ok' }, { k: 'EIR lúc trả rỗng', v: 'Chạm để chụp', state: 'cap' }, { k: 'Ảnh seal', v: '1 ảnh', state: 'ok' }, { k: 'Ảnh hư hỏng', v: 'Chạm để chụp', state: 'cap' }];
}
